import { useEffect, useRef } from "react";

type TurnstileWidgetProps = {
  isActive: boolean;
  siteKey?: string;
  widgetId: string | null;
  setWidgetId: (id: string | null) => void;
  onTokenChange: (token: string) => void;
  onError: () => void;
};

export const TurnstileWidget = ({
  isActive,
  siteKey = "0x4AAAAAAB6GJ-kn8z1tVMrZ",
  widgetId,
  setWidgetId,
  onTokenChange,
  onError,
}: TurnstileWidgetProps) => {
  const turnstileRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isActive || !turnstileRef.current) {
      return;
    }

    let checkInterval: number | undefined;

    const renderWidget = () => {
      if (window.turnstile && turnstileRef.current && !widgetId) {
        const renderedWidgetId = window.turnstile.render(turnstileRef.current, {
          sitekey: siteKey,
          callback: (token: string) => {
            onTokenChange(token);
          },
          "error-callback": () => {
            onError();
          },
          theme: "light",
        });
        setWidgetId(renderedWidgetId);
      }
    };

    if (window.turnstile) {
      renderWidget();
    } else {
      checkInterval = window.setInterval(() => {
        if (window.turnstile) {
          renderWidget();
          if (checkInterval) {
            clearInterval(checkInterval);
          }
        }
      }, 100);
    }

    return () => {
      if (checkInterval) {
        clearInterval(checkInterval);
      }
    };
  }, [isActive, onError, onTokenChange, setWidgetId, siteKey, widgetId]);

  useEffect(() => {
    if (!isActive && widgetId && window.turnstile) {
      window.turnstile.remove(widgetId);
      setWidgetId(null);
    }
  }, [isActive, setWidgetId, widgetId]);

  useEffect(() => {
    return () => {
      if (widgetId && window.turnstile) {
        window.turnstile.remove(widgetId);
      }
    };
  }, [widgetId]);

  return (
    <div className="flex justify-center">
      <div ref={turnstileRef}></div>
    </div>
  );
};
